import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6707fb55"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "top-margin"
}
const _hoisted_2 = { class: "main-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "or-text" }, "または", -1))
const _hoisted_4 = { class: "browse-label" }
const _hoisted_5 = ["accept"]
const _hoisted_6 = {
  key: 1,
  class: "sub-text"
}
const _hoisted_7 = { class: "selected-file-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "upload-area-container",
    "data-testid": "upload-area",
    onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
    onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropFile && _ctx.dropFile(...args)), ["prevent"]))
  }, [
    (_ctx.selectedFile == null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.subText != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true),
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: ['fas', 'cloud-upload-alt'],
            size: "2x"
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.mainText), 1),
          _hoisted_3,
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.buttonText), 1),
            _createElementVNode("input", {
              type: "file",
              "data-testid": "upload-input",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args))),
              accept: _ctx.accept
            }, null, 40, _hoisted_5)
          ]),
          (_ctx.subText != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.subText), 1))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.hovering)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                "data-testid": "cancel-button",
                class: "cancel-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unselectFile && _ctx.unselectFile(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'times'] })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fileName), 1)
        ], 64))
  ], 32))
}